"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

exports.__esModule = true;
exports.CardProductTag = exports.PrimaryCta = exports.CtaWrap = void 0;

var _styled = _interopRequireDefault(require("@emotion/styled"));

var _rebass = require("rebass");

var _Button = _interopRequireDefault(require("../../Button"));

var _Typography = require("../../Typography");

var CtaWrap = (0, _styled.default)(_rebass.Flex)(function (_ref) {
  var space = _ref.theme.space,
      hasSecondaryCta = _ref.hasSecondaryCta;
  return {
    justifyContent: hasSecondaryCta ? 'flex-start' : 'space-between',
    alignItems: 'center',
    marginTop: space.base
  };
});
exports.CtaWrap = CtaWrap;
var PrimaryCta = (0, _styled.default)(_Button.default)(function (_ref2) {
  var space = _ref2.theme.space,
      hasSecondaryCta = _ref2.hasSecondaryCta;
  return {
    marginRight: hasSecondaryCta ? space.base : '0',
    width: 'auto'
  };
});
exports.PrimaryCta = PrimaryCta;
var CardProductTag = (0, _styled.default)(_Typography.Body)(function (_ref3) {
  var _ref3$theme = _ref3.theme,
      colors = _ref3$theme.colors,
      space = _ref3$theme.space;
  return {
    marginBottom: space.small,
    color: colors.offblack
  };
});
exports.CardProductTag = CardProductTag;